import React from 'react';
import { ClockIcon, AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  label: string;
  note?: string;
  progress?: number;
}
export function Countdown({
  label,
  note,
  progress
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    unit: 'hs'
  }, {
    value: minutes,
    unit: 'min'
  }, {
    value: seconds,
    unit: 'seg'
  }];
  return <div className="rounded-2xl border border-ink-700 bg-ink-900 p-6 text-center sm:p-8" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-37" data-mp="3h1ie7uqc572n">
      <p className="flex items-center justify-center gap-2 font-display text-[11px] font-700 uppercase tracking-[0.24em] text-gold" style={{
      fontSize: "14px"
    }} data-id="element-38" data-mp="325jaewa9dt3b">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-39" data-mp="10dmy3kg9of7h" />
        {label}
      </p>

      <div className="mt-5 flex items-center justify-center gap-2 sm:gap-3" data-id="element-40" data-mp="15bocvt6ntsd5">
        {units.map((item, index) => <React.Fragment key={item.unit} data-id="element-41" data-mp="y04zqcrca2v9" data-mpi={index}>
            <div className="min-w-[72px] rounded-lg bg-ink-950 px-3 py-3 sm:min-w-[92px]" data-id="element-42" data-mp="xytue8i8wn21">
              <span className="block font-display text-3xl font-900 tabular-nums text-white sm:text-4xl" data-id="element-43" data-mp="szzbz7o6x0ig">
                {item.value}
              </span>
              <span className="mt-1 block text-[11px] uppercase tracking-widest text-slate-500" data-id="element-44" data-mp="12sy2iv38z14p">
                {item.unit}
              </span>
            </div>
            {index < units.length - 1 && <span aria-hidden="true" className="font-display text-2xl text-ink-600" data-id="element-45" data-mp="a40xvuryl2uf">
                :
              </span>}
          </React.Fragment>)}
      </div>

      {note && <p className="mt-5 flex items-center justify-center gap-2 text-sm text-slate-400" data-id="element-46" data-mp="k1f1gtss9x5b">
          <AlertTriangleIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-47" data-mp="1zi5p86flrga7" />
          {note}
        </p>}

      {typeof progress === 'number' && <div className="mx-auto mt-6 max-w-md text-left" data-id="element-48" data-mp="1vfithuft9b7q">
          <div className="flex items-center justify-between text-xs text-slate-400" data-id="element-49" data-mp="s5n5cy4afma2">
            <span data-id="element-50" data-mp="s7r9nh63mnav">Cupos al precio de lanzamiento</span>
            <span className="font-600 text-white" data-id="element-51" data-mp="x3oo1hxsxjl0">{progress}% tomados</span>
          </div>
          <div className="mt-2 h-2 overflow-hidden rounded-full bg-ink-950" role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos al precio de lanzamiento" data-id="element-52" data-mp="123ks1h6i1b0k">
            <div className="h-full rounded-full bg-alert" style={{
          width: `${progress}%`
        }} data-id="element-53" data-mp="9g8535wff16q" />
          </div>
        </div>}
    </div>;
}